import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    width: 280px;
    height: 135px;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid ${theme.colors.background.hover};
    background: ${theme.colors.lightest};
    box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover};
    display: flex;
    justify-content: space-between;
  `}
`

export const LeftBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Label = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: ${theme.colors.secondary};
    display: flex;
    align-items: center;
    gap: 3px;
  `}
`

export const Value = styled(Box)`
  ${({ theme }) => css`
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.48px;
    color: ${theme.colors.secondary};
  `}
`

export const IconBox = styled(Box)`
  ${() => css`
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  `}
`

export const BottomText = styled(Box)`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.32px;
`
